import { render, staticRenderFns } from "./PatientTests.vue?vue&type=template&id=22da7625&scoped=true"
import script from "./PatientTests.vue?vue&type=script&lang=js"
export * from "./PatientTests.vue?vue&type=script&lang=js"
import style0 from "./PatientTests.vue?vue&type=style&index=0&id=22da7625&prod&scoped=true&lang=css"
import style1 from "./PatientTests.vue?vue&type=style&index=1&id=22da7625&prod&lang=scss"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "22da7625",
  null
  
)

export default component.exports